import PropTypes from 'prop-types';
import React from 'react';

import Icon from '../components/icon';
import Countdown from '../components/Countdown';

import rightArrow from '../components/icon/icons-arrow.icon';
import closeIcon from '../components/icon/icons-close.icon';

class SessionItem extends React.Component {
    constructor(props) {
        super(props);

        this._toggleItem = this._toggleItem.bind(this);

        this.state = {
            isOpen: false,
        };
    }

    _toggleItem(e) {
        e.preventDefault();

        if (typeof ga !== "undefined") ga('send', 'event', 'Autechre', 'Item', this.state.isOpen ? 'Close' : 'Open');

        this.setState({
            isOpen: !this.state.isOpen,
        });
    }

    _logClick(action) {
        if (typeof ga !== "undefined") ga('send', 'event', 'Autechre', action);
    }

    _renderSessionSubtitle() {
        if (this.props.session.hasFinished()) return null;

        const now = new Date();
        if (now.valueOf() > this.props.session.startMoment.valueOf()) {
            return (
                <div className="session-item__left__heading__subtitle">Ends in <Countdown endMoment={this.props.session.endMoment} /></div>
            )
        }

        return (
            <div className="session-item__left__heading__subtitle">Live on {this.props.session.broadcastStartDate}, {this.props.session.broadcastStartTimeShort}</div>
        )
    }

    render() {
        const isOpenClass = this.state.isOpen ? 'session-item--open' : '';
        const hideOpenBtnClass = this.state.isOpen ? 'hidden-transition' : '';
        const hideCloseBtnClass = this.state.isOpen ? '' : 'hidden-transition';

        return (
            <div className={`session-item ${isOpenClass} ${this.props.className || ''}`}>
                <div className="session-item__left">
                    <div className="session-item__left__img-container" >
                        <img src={this.props.artwork} />
                    </div>

                    <div className="session-item__left__heading">
                        <div className="session-item__left__heading__title"><span className="text-bold">Autechre.</span> {this.props.session.name}.</div>
                        {this._renderSessionSubtitle()}
                    </div>

                    <div className="session-item__left__footer">
                        <div className={`session-item__left__footer__buy`}>
                            <a className={`${hideOpenBtnClass} text-uppercase cursor-pointer no-text-select`} onClick={this._toggleItem}>
                                Buy
                                <Icon icon={rightArrow} />
                            </a>
                            <a className={`${hideCloseBtnClass} session-item__close-btn-mobile hidden-desktop text-uppercase cursor-pointer no-text-select`} onClick={this._toggleItem}>
                                Close
                                <Icon icon={closeIcon} />
                            </a>
                        </div>
                    </div>
                </div>

                {/* Bleep shop is drawn into below */}
                <div className="session-item__right" />

                <div className="session-item__boxset" >
                    <a className="session-item__boxset__button nts-btn text-uppercase" target="_blank" href={this.props.shopBundleUrl} onClick={() => this._logClick("GoTo-BoxSet")}>Buy box set</a>
                    <div className="session-item__boxset__label">Buy box set or download bundles of all 4 sessions.</div>
                </div>

                <a className={`session-item__close-btn hidden-mobile ${hideCloseBtnClass} no-text-select`} onClick={this._toggleItem}>
                    close
                    <Icon icon={closeIcon} />
                </a>
            </div>
        );
    }
}

SessionItem.propTypes = {
    session: PropTypes.object.isRequired,
    className: PropTypes.string,
    shopBundleUrl: PropTypes.string.isRequired,
    artwork: PropTypes.string.isRequired,
};

export default SessionItem;



// WEBPACK FOOTER //
// ./src/components/SessionItem.jsx